import { message, Spin } from "antd";
import { uploadImageToS3 } from "api/news";
import { updateUserImage } from "api/userManagement";
import { base64ToBlob } from "components/CreateNews/components/helper";
import ModalFooter from "components/Modal/modalFooter";
import { useEffect, useRef, useState } from "react";
import { EditIcon } from "themes/Icon";
import ModalComp from "../Modal";
import style from "./profile_upload.module.scss";
import "./profile_upload.scss";

function ProfileUpload({
  picture,
  data = [],
  fileList,
  fetchUsers,
  fetchUser,
  setFileList = () => {},
  previewImage,
  setPreviewImage = () => {},
}) {
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const defaultImageUrl = "/svg/upload-default.svg";
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    setPreviewImage(picture);
  }, [picture]);

  const callUpdateImageAPI = async (fileObj, actionType, filepath) => {
    const payload = {
      admin_user_id: data.admin_user_id,
      action: actionType,
      images:
        actionType !== "delete"
          ? [
              {
                user_image_name: fileObj.name,
                user_image_size: fileObj.size,
                user_image_mimetype: fileObj.type,
                user_image_filepath: filepath,
              },
            ]
          : [],
    };

    try {
      const response = await updateUserImage(payload);
      message.success(response.message);
      fetchUser();
      fetchUsers();
      return response;
    } catch (error) {
      message.error("Failed to update user image");
      throw error; // To handle in calling function
    }
  };

  const handleFileInputChange = async (e) => {
    const newFileObject = e.target.files[0];
    if (newFileObject) {
      setLoading(true);
      try {
        const previewImageUrl = await getBase64(newFileObject);
        setPreviewImage(previewImageUrl);
        setPreviewTitle(newFileObject.name);
        setFileList([{ uid: Date.now(), originFileObj: newFileObject }]);

        // First upload to S3
        const userImageBlob = base64ToBlob(previewImageUrl);
        await uploadImageToS3(userImageBlob, data?.user_image_upload_path);
        // Call the API for update action with the path returned from S3 upload
        await callUpdateImageAPI(
          newFileObject,
          data.user_image ? "update" : "insert",
          data?.user_image_upload_filepath
        );
        setLoading(false);
      } catch (error) {
        message.error("Failed to process file: " + error.message);
        setLoading(false);
      }
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await callUpdateImageAPI(null, "delete");
      setPreviewImage(null);
      setPreviewTitle("");
      setFileList([]);
      setPreviewOpen(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={style["avatar-upload-container"]}>
        <div
          onClick={() => {
            if (fileList.length || previewImage) {
              setPreviewOpen(true);
            }
          }}
        >
          <div
            className={style["avatar-uploader"]}
            style={{ position: "relative" }}
          >
            <img
              src={previewImage ? previewImage : defaultImageUrl}
              alt="preview"
              className={style["avatar-image"]}
            />
            {loading && (
              <div className={style["spinner-overlay"]}>
                <Spin size="large" />
              </div>
            )}
          </div>
        </div>
        <button
          className={`${style["upload-btn"]} ${
            fileList?.length ? style["upload-btn-hidden"] : ""
          }`}
          onClick={() => fileInputRef.current?.click()}
        >
          <EditIcon />
        </button>
        <input
          ref={fileInputRef}
          type="file"
          style={{ display: "none" }}
          onChange={handleFileInputChange}
          accept="image/png, image/jpeg, image/jpg"
        />
      </div>
      <ModalComp
        setOpen={setPreviewOpen}
        footer={
          <ModalFooter
            handlePrimaryBtn={handleDelete}
            primaryBtnVariant="secondary"
            // primaryBtnText="Delete"
            hidePrimaryBtn
            hide
            primaryBtnloading={loading}
            hideSecondaryBtn={true}
          />
        }
        open={previewOpen}
        title="Profile photo"
      >
        <img
          className={style["preview-image"]}
          alt={previewTitle}
          src={previewImage != null ? previewImage : defaultImageUrl}
        />
      </ModalComp>
    </>
  );
}

export default ProfileUpload;
